import styles from './FilterBar.module.scss';
import FilterSelect from './filter-select/FilterSelect';
import { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import { getCategoriesToMap } from '../../lib/util';
import { ResultSortType } from '../../pages/results';

interface IFilterOption {
  name: string;
  value: any;
}

const FilterBar = (props: any) => {
  const appContext = useContext(AppContext);
  const specialties: IFilterOption[] = getCategoriesToMap(true, appContext).map((x) => {
    return { name: x, value: x };
  });
  const acceptanceStatuses: IFilterOption[] = [
    { name: 'Accepting New Patients', value: 'Yes' },
    { name: 'Any Acceptance Status', value: '' },
    { name: 'Not Accepting New Patients', value: 'No' }
  ];
  const filterStatuses: IFilterOption[] = [
    { name: 'None', value: ResultSortType.none },
    { name: 'Names A-Z', value: ResultSortType.namesAsc },
    { name: 'Names Z-A', value: ResultSortType.namesDesc },
    { name: 'Specialty A-Z', value: ResultSortType.specialtiesAsc },
    { name: 'Specialty Z-A', value: ResultSortType.specialtiesDesc },
    { name: 'AcceptanceStatus A-Z', value: ResultSortType.acceptanceStatusAsc },
    { name: 'AcceptanceStatus Z-A', value: ResultSortType.acceptanceStatusDesc }
  ];

  return (
    <div className={styles.filterBarContainer}>
      <div>
        <span className={styles.resultsText}>{props.resultCount || 'No'} Results Found</span>
        <FilterSelect filterData={specialties} sortBy={false} filterIndex={0} resultsFilterMethod={props.resultsFilterMethod} resultsFilterValue={props.resultsFilterValue} />
        <FilterSelect filterData={acceptanceStatuses} sortBy={false} filterIndex={1} resultsFilterMethod={props.resultsFilterMethod} resultsFilterValue={props.resultsFilterValue} />
      </div>
      <div>
        <FilterSelect filterData={filterStatuses} sortBy={true} filterIndex={2} resultsFilterMethod={props.resultsFilterMethod} resultsFilterValue={props.resultsFilterValue} />
      </div>
    </div>
  );
};

export default FilterBar;
